import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toast } from 'sonner';
import { BaseModal } from 'wbs-components-lib';

import { useCreateVipLevelMutation } from '@services';

import { AppDispatch, getVipLevelsSelector, setVipLevel } from '@store';

import { VIP_LEVEL_FORM_INITIAL_VALUES, VipLevelForm, VipLevelFormValues } from '../../VipSettingsForms';

import { VipLevelCreateModalProps } from './types';

export const VipLevelCreateModal: FC<VipLevelCreateModalProps> = ({ isOpened, handleClose }) => {
  const dispatch = useDispatch<AppDispatch>();

  const levels = useSelector(getVipLevelsSelector);
  const lastLevel = levels[levels.length - 1]?.level;

  const [createVipLevel, { isLoading: isCreatingInProgress }] = useCreateVipLevelMutation();

  const handleCreateVipLevel = async (values: VipLevelFormValues) => {
    const createdVipLevel = await createVipLevel(values).unwrap();

    dispatch(setVipLevel(createdVipLevel));

    toast.success('Success: Vip level has been created!');

    handleClose();
  };

  return (
    <BaseModal headerTitle="Create VIP level" isOpened={isOpened} handleClose={handleClose} isFooterNeeded={false}>
      <VipLevelForm
        initialValues={{
          ...VIP_LEVEL_FORM_INITIAL_VALUES,
          level: lastLevel !== undefined ? lastLevel + 1 : 0,
        }}
        isSubmitting={isCreatingInProgress}
        onSubmit={handleCreateVipLevel}
      />
    </BaseModal>
  );
};
